/* custom order tracking page */
(($) => {$(() => {
           
    Handlebars.registerHelper('productThumb', function(src) {
      return src.replace(
          /\.(?=[^.]*$)/,
          '_200x_crop_center.'
        );
    });

    let _trackOrder = () => {
  		
  		let orderName = document.getElementById('ordertracking_name').value,
  			orderEmail = document.getElementById('ordertracking_email').value,
            wrap = document.getElementById('ordertracking_wrap');
  
  		wrap.style.opacity = '0.5';
  		
  		appRequest(`/order/search?name=${orderName}&email=${orderEmail}`)
        	.then(r => r.json())
			.then(order => {
          
          		console.log(order);

          		let html = '';
          		if (!order.id) {
                  html += `<p>Unable to find the order #${orderName} associated with email ${orderEmail}.</p>`;
                }
          		else {
                  
                  let d = new Date(order.created_at);
              	  order.date_formatted = d.toLocaleString('en-us', { month: "long" }) + ' ' + d.getDate() + ', ' + d.getFullYear();
				  
                  let orderStatus = '';
                  if (order.tags.indexOf('S:') > -1) {
                    orderStatus = order.tags.split('S:');
                    if (orderStatus.length > 1) {
                      orderStatus = orderStatus[1].split(',')[0].trim();
                    }
                    orderStatus = orderStatus.replace('IP - ', '');
                  }
                  if (order.financial_status == 'paid' && order.fulfillment_status == 'fulfilled') {
                    orderStatus = 'Order Shipped';
                  }
                  let icons = {
                    'In stock & prepping for shipment': "//viesso.com/cdn/shop/t/42/assets/order-in-stock-being-prepped-for-shipment.svg?v=14197550357183870401748477508",
                    'Confirming estimated timing': "//viesso.com/cdn/shop/t/42/assets/confirming-estimated-timing.svg?v=108871339590575903401748477508",
                    'Full order being built': "//viesso.com/cdn/shop/t/42/assets/full-order-being-built.svg?v=95261553262050277871748477508",
                    'Item made & shipping to the US': "//viesso.com/cdn/shop/t/42/assets/item-made-being-shipped-to-us.svg?v=271130552586094751748477508",
                    'Waiting for customer response': "//viesso.com/cdn/shop/t/42/assets/waiting-for-customer.svg?v=182893935612032248391748477508",
                    'Some in stock & rest out of stock': "//viesso.com/cdn/shop/t/42/assets/part-of-order-in-stock-the-rest-out-of-stock.svg?v=67145646704440775031748477508",
                    'Some shipped & rest not ready': "//viesso.com/cdn/shop/t/42/assets/part-of-order-shipped-rest-not-ready.svg?v=271130552586094751748477508",
                    'Order Shipped': "//viesso.com/cdn/shop/t/42/assets/complete.svg?v=23163616923967748181748477508",
                  };
                  order.custom_status = `${order.financial_status}, ${order.fulfillment_status}`;
                  let status_image = '//viesso.com/cdn/shop/t/42/assets/preparing-order.svg?51354';
                  if (orderStatus && orderStatus != '') {
                    order.custom_status = orderStatus;
                    status_image = icons[orderStatus];
                  }
                  order.status_image = `<img src="${status_image}" />`;;
                  
                  order.order_esd = '';
                  let order_esd = order.tags.split('ESD:');
                  if (order_esd.length > 1) {
                  	order.order_esd = order_esd[1].split(',')[0].trim();
                  }
                  
                  order.shipping_title = '';
                  if (order.shipping_lines && order.shipping_lines.length) {
                    order.shipping_title = order.shipping_lines[0].title;
                  }
                  let sa = order.shipping_address;
                  order.ship_to = `
					${sa.first_name} ${sa.last_name}<br/>
					${sa.address1}<br/>
					${sa.city}, ${sa.province}, ${sa.zip}<br/>
					${sa.country}<br/>
					T: ${sa.phone}
				  `;

                  order.tracking_link = '';
                  if (order.fulfillments && order.fulfillments.length) {
                    order.tracking_link = `<a href="${order.fulfillments[0].tracking_url}" target="_blank">${order.fulfillments[0].tracking_company} tracking</a>`;
                  }
                  
                  order.line_items = order.line_items.filter(li => {
                    let show = true;
                    li.properties.map(lip => {
                      if (lip.name.toLowerCase().trim() == 'for product') {
                        show = false;
                      }
                    });
                    return show;
                  });
                                    
                  let template = Handlebars.compile(document.getElementById('ordertracking_template').innerHTML);
                  html = template(order);

                }
          
          		document.getElementById('ordertracking_result').innerHTML = html;
          		wrap.style.opacity = '1';
        	
        	});

  		return false;
	
	};

    document.getElementById('ordertracking_submit').onclick = _trackOrder;
    document.querySelectorAll('#ordertracking_name, #ordertracking_email').forEach(el => {
      el.onkeypress = (e) => {
        if (e.keyCode == 13) { _trackOrder(); }
      }
    });

})})(jQuery);